import { render } from "./AppealList.vue?vue&type=template&id=655dbec6"
import script from "./AppealList.vue?vue&type=script&lang=js"
export * from "./AppealList.vue?vue&type=script&lang=js"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__